import { PMS_URL } from "utils/constants";

// Year, Make, Model
export const getYMM = (path, newfinder) => fetch(
    `${PMS_URL}/vehicle_details?vehicle_type=${path}&newfinder=${newfinder ? 'true' : 'false'}`,
    {
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        method: "GET", 
    },
).then((data) => data.json());

// get ymm all
export const getYMMAll = (path, newfinder) => fetch(
    `${PMS_URL}/vehicle_details/fetch_finder_data?vehicle_type=${path}&newfinder=${newfinder ? 'true' : 'false'}`,
    {
        headers: { "Content-Type": "application/json" },
        mode: "cors",
        method: "GET",
    },
).then((data) => data.json());

export default getYMM;
